export const getNumberUpToPoint = (str) => Number(str.split('.')[0]);

export const getPreparedFlats = (flats) => {
  const obj = {};

  const preparedFlats = flats.reduce((acc, flat) => {
    if (flat.size < 1) {
      const flatNum = flat.flat.replace(/\D/g, '');

      if (obj[flatNum] === undefined) {
        obj[flatNum] = [flat];

        Object.values(obj).forEach((value) => {
          acc.push(value);
        });
      } else {
        obj[flatNum].push(flat);
      }
    } else {
      acc.push(flat);
    }

    return acc;
  }, []);

  const upperRooms = [];
  const basementRooms = [];
  const undergroundRooms = [];

  preparedFlats.forEach((flat) => {
    if (Array.isArray(flat)) {
      if (flat.some((item) => item.floor > 0)) {
        upperRooms.push(flat);
      }

      if (flat.some((item) => item.floor === 0)) {
        basementRooms.push(flat);
      }

      if (flat.some((item) => item.floor < 0)) {
        undergroundRooms.push(flat);
      }
    } else {
      if (flat.floor > 0) {
        upperRooms.push(flat);
      }

      if (flat.floor === 0) {
        basementRooms.push(flat);
      }

      if (flat.floor < 0) {
        undergroundRooms.push(flat);
      }
    }
  });

  return {
    upperRooms,
    basementRooms,
    undergroundRooms,
  };
};

export const getNumOfCol = (flats) => {
  const columnsCount = flats.map((flat) => {
    const cols = flat.cells.map((cell) => Math.trunc(cell.col));

    return cols.length > 1 ? Math.max(...cols) : cols[0];
  });

  return Math.max(...columnsCount);
};
